import React from 'react';
import { useSelector } from 'react-redux';
import {
  seoStateSelector,
  faqsSelector
} from '@stencil/flights-seo-reducers/src/SRP/redux/selectors';
import insertAnElementIntoArrayAtSpecificIndex from '@stencil/flights-utils/src/insert-an-element-into-array-at-specific-index';
import AboutCity from '@stencil/commonstories/src/components/Seo/about-city/about-city';
import FAQs from '@stencil/commonstories/src/components/Seo/faqs/faqs';

const SeoCheapFlightsRight = props => {
  const seoState = useSelector(seoStateSelector);
  const faqs = useSelector(faqsSelector);
  const {
    queryType,
    h_1_header,
    write_up,
    cheapFlightsContent,
    extraContent,
    extraContentPosition
  } = seoState;
  let routeInfoElements = [
    <AboutCity title={h_1_header} longDesc={write_up} isDweb={true} shouldBeH1={true} />,
    ...(cheapFlightsContent
      ? [<AboutCity title="" longDesc={cheapFlightsContent.api_url} isDweb={true} />]
      : []),
    ...(faqs && faqs.length
      ? [<FAQs faqs={faqs} isDweb={true} sector="About Cheap Flights" />]
      : [])
  ];
  routeInfoElements = extraContent
    ? insertAnElementIntoArrayAtSpecificIndex(
        routeInfoElements,
        extraContentPosition,
        <AboutCity title="" longDesc={extraContent} isDweb={true} />
      )
    : routeInfoElements;

  return (
    <>
      {routeInfoElements.map((element, index) => {
        return <div key={index}>{element}</div>;
      })}
    </>
  );
};

export default SeoCheapFlightsRight;
